module.exports = __webpack_public_path__ + "static/media/ambiente_01.b8efbc41.jpg";